module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACnSURBVBhXYxSbfXX+f4b/ra9Tde4wYAGi869IMP5hnMwEVLSS4T/DepAAVA4ORKdc4QEqWs3A8G8nE9CkHUCxRqDAdpAERAkQ1O9nYWRnnA805MirVN05TCCx12k6a4C6pjKyMW4GKQCJiUqLTQdSX16laVeC+IwgAgZEZ19tAFLqQPwCKCHz6smrSIZGxz8gORSFICA6+wrIJJXXT157whQxMDAwAACeRTlPzc+CRwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/editDown.png
// module id = 1032
// module chunks = 0